<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">

        <div class="col-xl-3 col-md-6">
          <a style="cursor: pointer;" href="/admin/users/drivers">
            <stats-card>
              <div slot="header" class="icon-warning">
                <img src="../../public/img/driverChami .png"
                  style="height: 50px; margin-left: 20px; margin-bottom: 15px;">
              </div>
              <div slot="content">
                <p class="card-category">Conductoras</p>
                <h4 class="card-title">{{ counterNumDrivers }}</h4>
              </div>
              <!--<div slot="footer">
              <i class="fa fa-refresh"></i>Actualizar
            </div>-->
            </stats-card>
          </a>
        </div>


        <div class="col-xl-3 col-md-6">
          <a style="cursor: pointer;" href="/admin/users/children">
            <stats-card>
              <div slot="header" class="icon-success">
                <img src="../../public/img/childrenChami .png"
                  style="height: 50px; margin-left: 20px; margin-bottom: 15px;">
              </div>
              <div slot="content">
                <p class="card-category">Chamis</p>
                <h4 class="card-title">{{ counterNumRiders }}</h4>
              </div>
              <!--<div slot="footer">
              <i class="fa fa-calendar-o"></i>Last day
            </div>-->
            </stats-card>
          </a>
        </div>

        <div class="col-xl-3 col-md-6">
          <a style="cursor: pointer;" href="/admin/services">
            <stats-card>
              <div slot="header" class="icon-danger">
                <img src="../../public/img/routeChami .png" style="height: 50px; margin-left: 20px; margin-bottom: 15px;">
              </div>
              <div slot="content">
                <p class="card-category">Rides</p>
                <h4 class="card-title">{{ counterNumServices }}</h4>
              </div>
              <!-- <div slot="footer">
              <i class="fa fa-clock-o"></i>Last day
            </div>-->
            </stats-card>
          </a>
        </div>

        <div class="col-xl-3 col-md-6">
          <a style="cursor: pointer;" href="/admin/paymentsr">
            <stats-card>
              <div slot="header" class="icon-info">
                <img src="../../public/img/plansChami .png" style="height: 50px; margin-left: 30px; margin-bottom: 15px;">
              </div>
              <div slot="content">
                <p class="card-category">Pagos</p>
                <h4 class="card-title">{{ counterPaymentTotal }}</h4>
              </div>
              <!-- <div slot="footer">
              <i class="fa fa-refresh"></i>Updated now
            </div>-->
            </stats-card>
          </a>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <chart-card :chart-data="lineChart.data" :chart-options="lineChart.options"
            :responsive-options="lineChart.responsiveOptions" :key="lineChartKey">
            <template slot="header">
              <h4 class="card-title">Conductoras afiliadas</h4>
              <h5 class="card-category text-center" style="text-transform: capitalize; color: black">
                <strong>{{ currentMonth }}</strong>
              </h5>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle" style="color: #651366;"></i> Conductoras
                <!-- <i class="fa fa-circle text-danger"></i> Choferes - Drivers -->
              </div>

              <!--<hr> <div class="stats">
               <i class="fa fa-history"></i> Actualizado hace 3 minutos 
              </div>-->
            </template>
          </chart-card>
        </div>

        <div class="col-md-4">
          <chart-card :chart-data="pieChart.data" chart-type="Pie" :key="pieChartKey" class="pie-chart">
            <template slot="header">
              <h4 class="card-title">Subscripciones</h4>
              <p class="card-category">Según el plan</p>
            </template>
            <template slot="footer">
              <div class="legend" v-for="item in TypeSubscriptionsTmp" style="margin-right: 8px;">
                <i class="fa fa-circle" :style="'color:' + item.color.code + ';'"></i>{{ item.name }}
              </div>
              <!--<hr>
              <div class="stats">
                <i class="fa fa-clock-o"></i> Actualizado hace 3 minutos
              </div>-->
            </template>
          </chart-card>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <chart-card :chart-data="barChart.data" :chart-options="barChart.options"
            :chart-responsive-options="barChart.responsiveOptions" chart-type="Bar" :key="barChartKey">
            <template slot="header">
              <h4 class="card-title">Rides</h4>
              <p class="card-category">Basado en los servicios generados</p>
            </template>
            <template slot="footer">
              <div class="legend"></div>
              <!-- <hr>
              <div class="stats">

              </div> -->
            </template>
          </chart-card>
        </div>

        <div class="col-md-6">
          <card>
            <template slot="header">
              <h5 class="card-title">Últimos usuarios registrados</h5>
              <p class="card-category mb-3">Desde la aplicación</p>
              <div v-for="user in latestUsers" class="timeline-content">
                <div class="row">
                  <div
                    v-if="user.url_image && user.url_image != null && user.url_image != '' && user.url_image != undefined"
                    class="col-md-1" style="width: 40px; margin-right: 18px;">
                    <img :src="user.url_image" class="rounded-circle shadow-4-strong avatar-sm me-0 mb-0"
                      style="height: 40px;" alt="xd" />
                  </div>
                  <div v-else class="col-md-1" style="width: 40px; margin-right: 18px;">
                    <img src="../../public/img/logochami.png" class="rounded-circle shadow-4-strong avatar-sm me-0 mb-0"
                      alt="xd" style="height: 40px;" />
                  </div>

                  <div class="col-md-9 mb-0 p-0" style="margin-top: 9px;">
                    <p class="text-dark card-category font-weight-bold mb-0">
                      {{ user.first_name }} {{ user.last_name }}
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <p class="text-secondary card-category mt-1 mb-2" style="font-size: 13px !important;">
                      {{ formatDate(user.created_at) }} </p>
                  </div>
                </div>


              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import ChartCard from "src/components/Cards/ChartCard.vue";
import StatsCard from "src/components/Cards/StatsCard.vue";
import LTable from "src/components/Table.vue";
import moment from "moment";

export default {
  components: {
    LTable,
    ChartCard,
    StatsCard,
    moment
  },
  data() {
    return {
      //VARIABLE
      finder: "",
      metaInfo: {},
      isBusy: false,
      UsersTmp: [],
      Users: [],
      currentMonth: "",
      paymentsTotal: 0,
      counterPaymentTotal: 0,

      //COUNTERS
      RidersTmp: [],
      SubscriptionsTmp: [],
      ServicesTmp: [],

      counterNumServices: 0,
      numServices: 0,
      counterNumRiders: 0,
      numRiders: 0,
      counterNumDrivers: 0,
      numDrivers: 0,

      maxInSeries: 0,

      TypeSubscriptionsTmp: [],

      chamiColors: [
        { code: "#651366" },
        { code: "#8cc540" },
        { code: "#f0c505" },
        { code: "#f3130b" },
      ],

      //DATA Variables
      latestUsers: [],
      analitics: [],
      editTooltip: "Edit Task",
      deleteTooltip: "Remove",
      barChartKey: 0,
      pieChartKey: 0,
      lineChartKey: 0,
      DriversTmp: [],
      pieChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          donut: true,
          donutWidth: 60,
          startAngle: 270,
          total: 200,
          showLabel: true,
          height: "245px",
        },
      },
      lineChart: {
        data: {
          labels: [],
          series: [],
        },

        options: {
          low: 0,
          high: 100,
          showArea: false,
          height: "245px",
          axisX: {
            showGrid: false,
          },
          lineSmooth: true,
          showLine: true,
          showPoint: true,
          fullWidth: true,
          chartPadding: {
            right: 50,
          },
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              axisX: {
                labelInterpolationFnc(value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },
      barChart: {
        data: {
          labels: ["Chamis transportados"],
          series: [],
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false,
          },
          height: "245px",
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc(value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },
    };
  },

  computed: {
    ...mapState({
      me: (state) => state.auth.me,
      me_rol: (state) => state.auth.me_rol,
    }),
    sortOptions() {
      return [];
    },
    rows() {
      return this.UsersTmp.length;
    },
  },
  mounted() {
    this.loadElements();
    // this.loadAnalitics();
    this.loadServices();
    this.loadRiders();
    this.loadDrivers();
    this.loadSubscriptions();
    this.loadTypeSubscriptions();
    this.loadPayments();
    this.loadDriversCount();
  },
  methods: {
    ...mapActions(["getData", "changeStatusData"]),
    goNew() {
      this.$router.push({ name: this.buttonNewUrl });
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    updateChartSubscription() {
      // Crear un objeto para almacenar los conteos
      const counts = {};

      // Contar las membresías por tipo
      this.SubscriptionsTmp.forEach(subscription => {
        let type;

        if (subscription.id_type_subscription != 0) {
          type = subscription.id_type_subscription;
        }
        else {
          type = 1;
        }

        if (!counts[type]) {
          counts[type] = 0;
        }

        counts[type]++;
      });

      // Actualizar los datos del gráfico
      this.pieChart.data.labels = [...this.TypeSubscriptionsTmp.map((item) => item.name)];
      this.pieChart.data.series = Object.values(counts);
      this.pieChartKey++;
    },

    updateChartData() {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      const currentYear = currentDate.getFullYear();
      this.currentMonth = currentDate.toLocaleString("default", {
        month: "long",
      });
      console.log(currentDate);
      console.log(currentMonth);
      console.log(currentYear);
      console.log(this.DriversTmp);
      // Filtrar los datos por el mes actual
      const filteredData = this.DriversTmp.filter((driver) => {
        const driverDate = new Date(driver.created_at);
        return (
          driverDate.getFullYear() === currentYear &&
          driverDate.getMonth() === currentMonth
        );
      });
      console.log('filter drivers:', filteredData);
      // Crear un objeto para almacenar los conteos
      const counts = {};

      // Contar las conductoras por día
      filteredData.forEach((driver) => {
        const driverDate = new Date(driver.created_at);
        const day = driverDate.getDate();

        if (!counts[day]) {
          counts[day] = 0;
        }

        counts[day]++;
      });

      // Actualizar los datos del gráfico
      this.lineChart.data.labels = Object.keys(counts);
      this.lineChart.data.series = [Object.values(counts).map(Number)];
      this.lineChartKey++;

      this.maxInSeries = Math.max(...this.lineChart.data.series[0]);
      this.lineChart.options.high = this.maxInSeries + 5;
      console.log('Series:', this.lineChart.data.series);
      console.log('LinesChart:', this.lineChart);
    },

    updateChartServices() {
      // Actualizar los datos del gráfico
      this.barChart.data.series[0] = [this.ServicesTmp.total];
      this.barChartKey++;

      // this.maxInSeries = Math.max(...this.lineChart.data.series[0]);
      // this.lineChart.options.high = this.maxInSeries + 5;
      console.log(this.barChart.data.series);
      console.log(this.barChart);
    },


    // loadAnalitics() {
    //   let year = new Date().getFullYear();
    //   let form = {
    //     url: 'analitic/analitics_charts',
    //     params: {
    //       year: year,
    //       // is_driver: 1,
    //       //active: 1,

    //     },
    //   };

    //   this.isBusy = true;
    //   this.getData(form)
    //     .then((response) => {
    //       this.isBusy = false;
    //       if (response.code === 200) {
    //         this.analitics = response.data;
    //         console.log(this.analitics)
    //         this.pieChart.data.series = this.analitics.gender_analitic.array_percentages;

    //         for (let i in this.analitics.gender_analitic.array_percentages) {
    //           this.pieChart.data.labels.push(this.analitics.gender_analitic.array_percentages[i] + ' %')
    //         }
    //         // for(let i in this.analitics.grow_users_analitics){
    //         //   this.lineChart.data.series.push(this.analitics.grow_users_analitics[i])
    //         // }
    //         console.log(this.analitics.grow_users_analitics);
    //         this.lineChart.data.series = this.analitics.grow_users_analitics;

    //         this.barChart.data.series[0] = this.analitics.grow_services_analitics;

    //         this.pieChartKey += 1;
    //         this.lineChartKey += 1;
    //         this.barChartKey += 1;
    //         this.$forceUpdate();
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
    loadDriversCount() {
      let form = {
        url: "user/all",
        params: {
          id_role: 2,
          is_driver: 1,
          active: 1,
        },
      };

      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.numDrivers = response.data.length;

            this.updateChartData();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadDrivers() {
      let form = {
        url: "user/all",
        params: {
          id_role: 2,
          is_driver: 1,
          active: 1,
        },
      };

      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.DriversTmp = response.data;

            this.updateChartData();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },


    loadPayments() {
      let form = {
        url: "/payment_report/all",
        params: {
          active: 1,
          page: 1,
        },
      };

      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.paymentsTotal = response.data.meta.total;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadRiders() {
      let form = {
        url: "user_children/all",
        params: {
          id_role: 2,
          is_rider: 1,
          active: 1,
        },
      };

      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.numRiders = response.data.length;
            this.RidersTmp = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadServices() {
      let form = {
        url: "service/all",
        params: {
          active: 1,
          page: 1,
        },
      };

      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.numServices = response.data.meta.total;
            this.ServicesTmp = response.data.meta;

            this.updateChartServices();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadSubscriptions() {
      let form = {
        url: "subscription/all",
        params: {
          active: 1,
        },
      };

      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            // this.numServices = response.data.length;
            this.SubscriptionsTmp = response.data;

            this.updateChartSubscription();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadTypeSubscriptions() {
      let form = {
        url: "/master/type_subscription/all",
        params: {
          active: 1,
        },
      };

      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            // this.numServices = response.data.length;
            this.TypeSubscriptionsTmp = response.data.map((item) => {
              return {
                id: item.id,
                name: item.name,
                color: this.chamiColors[item.id - 1],
              };
            })


            this.updateChartSubscription();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },




    loadElements() {
      let form = {
        url: "user/all",
        params: {
          active: 1,
          page: 1,
          limit: 5,
          order_key: "id",
          order_value: "desc",
        },
      };

      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.latestUsers = response.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  watch: {
    numServices(newVal, oldVal) {
      // Si la variable numServices cambia, actualizamos el contador
      this.counterNumServices = 0; // Reiniciamos el contador
      let interval = setInterval(() => {
        if (this.counterNumServices < newVal) {
          this.counterNumServices++;
        } else {
          clearInterval(interval); // Detenemos el contador cuando llegamos al número de servicios
        }
      }, 50); // Velocidad del contador (en milisegundos)
    },
    paymentsTotal(newVal, oldVal) {
      // Si la variable numServices cambia, actualizamos el contador
      this.counterPaymentTotal = 0; // Reiniciamos el contador
      let interval = setInterval(() => {
        if (this.counterPaymentTotal < newVal) {
          this.counterPaymentTotal++;
        } else {
          clearInterval(interval); // Detenemos el contador cuando llegamos al número de servicios
        }
      }, 50); // Velocidad del contador (en milisegundos)
    },
    numRiders(newVal, oldVal) {
      this.counterNumRiders = 0;
      let interval = setInterval(() => {
        if (this.counterNumRiders < newVal) {
          this.counterNumRiders++;
        } else {
          clearInterval(interval);
        }
      }, 50);
    },
    numDrivers(newVal, oldVal) {
      this.counterNumDrivers = 0;
      let interval = setInterval(() => {
        if (this.counterNumDrivers < newVal) {
          this.counterNumDrivers++;
        } else {
          clearInterval(interval);
        }
      }, 50);
    },
  },
};
</script>
<style>
.no-border-top thead {
  border-top: none;
}

.ct-series-a .ct-bar,
.ct-series-a .ct-line,
.ct-series-a .ct-slice-pie {
  fill: #651366;
}

.ct-series-b .ct-bar,
.ct-series-b .ct-line,
.ct-series-b .ct-slice-pie {
  fill: #8cc540;
}

.ct-series-c .ct-bar,
.ct-series-c .ct-line,
.ct-series-c .ct-slice-pie {
  fill: #f0c505;
}

.ct-series-d.ct-bar,
.ct-series-d .ct-line,
.ct-series-d .ct-slice-pie {
  fill: #f3130b;
}

.pie-chart .ct-label {
  fill: white !important;
  /* Cambia esto al color que desees */
}

.ct-labels-b .ct-slice-pie {
  fill: #8cc540;
}

.ct-labels-c .ct-slice-pie {
  fill: #f0c505;
}

.ct-labels-d .ct-slice-pie {
  fill: #f3130b;
}
</style>
<style scoped></style>
